import axios from "axios";
import i18n from "i18next";
import {
    WALLET_AI_TARIFF_BULK,
    WALLET_AI_TARIFF_QUOTE,
    WALLET_AI_TARIFFS,
    WALLET_COIN_PRICE_CURRENT,
    WALLET_COIN_PRICES,
} from "../../helperData/ApiAddress";

const headers = () => ({
    Authorization: sessionStorage.getItem("auth")
        ? `Bearer ${sessionStorage.getItem("auth")}`
        : undefined,
    "Accept-Language": i18n.language || "fa",
});

const unwrapList = (data) =>
    Array.isArray(data) ? data : data?.results || data?.items || [];

export const normalizeQuoteSpec = (spec) => {
    if (!spec) return [];
    const list = Array.isArray(spec) ? spec : [spec];
    return list
        .map((item) => {
            if (typeof item === "string") {
                return { operation: item, quantity: 1 };
            }
            return {
                operation: item.operation || item.code,
                quantity: Math.max(1, Number(item.quantity) || 1),
            };
        })
        .filter((item) => item.operation);
};

export const isInsufficientCoins = (error) =>
    error?.response?.status === 402 ||
    error?.response?.data?.code === "insufficient_coins";

export const aiBillingApi = {
    listTariffs: () =>
        axios
            .get(WALLET_AI_TARIFFS, { headers: headers() })
            .then((r) => unwrapList(r.data)),
    quote: (spec) => {
        const items = normalizeQuoteSpec(spec);
        if (items.length === 1) {
            return axios
                .get(WALLET_AI_TARIFF_QUOTE, {
                    headers: headers(),
                    params: {
                        operation: items[0].operation,
                        quantity: items[0].quantity,
                    },
                })
                .then((r) => r.data);
        }
        return axios
            .post(WALLET_AI_TARIFF_QUOTE, { items }, { headers: headers() })
            .then((r) => r.data);
    },
    saveTariffs: (items) =>
        axios
            .put(WALLET_AI_TARIFF_BULK, { items }, { headers: headers() })
            .then((r) => unwrapList(r.data)),
};

export const coinPriceApi = {
    current: () =>
        axios
            .get(WALLET_COIN_PRICE_CURRENT, { headers: headers() })
            .then((r) => r.data),
    publish: (rialPerCoin) =>
        axios
            .post(
                WALLET_COIN_PRICES,
                { rial_per_coin: rialPerCoin },
                { headers: headers() }
            )
            .then((r) => r.data),
};
